import React from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DataTable } from "./DataTable";
import useNavModel from "@/model/navModel";
import { useMergerModel } from "./summaryModel";
import { useDetailModel, ActionTypeEnum } from "../../../customerMerger/view/detail/detailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { accountService } from "@/views/account/AccountService";


export const DataBox = () => {
    const { addNav } = useNavModel(() => []);
    const { selectedRowKeys, onAddMerger, customerMergerExport } = useMergerModel();
    const { setCustomerCode, setActionType, setCustomerOptions } = useDetailModel(() => []);
   
    const onDetail = async () => {
        if (selectedRowKeys && selectedRowKeys.length === 1) {
            if (selectedRowKeys[0]?.id) {
                let {retData} = await accountService.customerMergeOne(selectedRowKeys[0].id)
                setCustomerCode(retData.map(i => i.customerCode));
                setCustomerOptions(retData.map(i => ({value: i.customerCode, label: i.customerName,})))
                setActionType(ActionTypeEnum.NULL)
                // addNav("2-3-1");
            }
            addNav("2-7-1");
        } else {
            message.error("请选择单条数据进行操作");
        }
    }


    const action = (
        <>
            {/* <YhAuth resCode={ResourceAuthEnum.ACC_C_VW}> */}
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onDetail}
                >
                    查看
                </Button>
            {/* </YhAuth> */}
            {/* <YhAuth resCode={ResourceAuthEnum.ACC_C_INIT}> */}
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAddMerger}
                >
                    客户合并
                </Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={customerMergerExport}
                >
                    导出
                </Button>
            {/* </YhAuth> */}
        </>
    );

    return (
        <YhBox title=" "  action={action}>
            <DataTable />
        </YhBox>
    )
}
